<template>
  <div>
    <b-table
      id="gift-cards-client-logs"
      ref="table"
      class="bg-white"
      small
      responsive
      :fields="fields"
      :items="logs"
    >
      <template #cell(gift_card_no)="data">
        <small class="text-muted" :title="data.item.id">#{{ (data.value) }}</small>
      </template>
      <template #cell(created_at)="data">
        <small :title="data.item.id">{{ moment(data.value).format('LLL') }}</small>
      </template>
      <template #cell(meta.receiving_recipient)="data">
        <div v-if="data.value">
          {{ data.value.name }}
          <small class="d-block">{{ data.value.email }}</small>
        </div>
      </template>
      <template #cell(operation)="data">
        {{ trans(data.value) }}
      </template>
      <template #cell(amount)="data">
        <span class="text-muted">
          {{ data.value }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      logs: Array,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        fields: _.compact([
          {key: 'gift_card_no', label: trans('card_no')},
          {key: 'meta.receiving_recipient', label: trans('to')},
          {key: 'created_at', label: trans('date')},
          {
            key: 'meta.amount',
            label: trans('amount'),
            formatter(value, key, item) {
              return _.isNumeric(value) ? _.currency(value) : null
            },
          },
        ]),
      }
    },
    mounted() {
      window.gitfCardModal = this
    },
  }
</script>